import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import TokenList from '../components/explore/TokenList';
import ChainToggle, { ChainFilter } from '../components/shared/ChainToggle';

// ============================================
// TRADE PAGE - Full Token List View
// This is the detailed trading view with all filters
// ============================================

const PageContainer = styled.div`
  padding: 24px;
  background: transparent;
  min-height: calc(100vh - 64px - 56px);
  
  @media (max-width: 768px) {
    padding: 16px;
  }
`;

const PageHeader = styled.div`
  margin-bottom: 24px;
`;

const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 8px 0;
`;

const PageSubtitle = styled.p`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
`;

// Chain toggle section
const ChainToggleSection = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
  
  @media (max-width: 768px) {
    margin-bottom: 16px;
  }
`;

// Search and filters section
const SearchSection = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  align-items: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const SearchInput = styled.input`
  flex: 1;
  padding: 12px 16px;
  background: var(--color-bg-card, #000000);
  border: 1px solid var(--color-border, #333333);
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  outline: none;
  transition: all 150ms ease;
  
  &::placeholder {
    color: #52525b;
  }
  
  &:focus {
    border-color: var(--color-border-light, #444444);
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.03);
  }
`;

const CreateButton = styled.button`
  padding: 12px 24px;
  background: #ffffff;
  color: #000000;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 150ms ease;
  white-space: nowrap;
  
  &:hover {
    background: #e4e4e7;
  }
`;

const TradePage: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedChain, setSelectedChain] = useState<ChainFilter>('ink');
  const navigate = useNavigate();

  return (
    <PageContainer>
      {/* Page Header */}
      <PageHeader>
        <PageTitle>Trade Tokens</PageTitle>
        <PageSubtitle>Browse, filter, and trade all tokens across chains</PageSubtitle>
      </PageHeader>

      {/* Chain Toggle */}
      <ChainToggleSection>
        <ChainToggle selectedChain={selectedChain} onChainChange={setSelectedChain} />
      </ChainToggleSection>
      
      {/* Search and Create */}
      <SearchSection>
        <SearchInput
          type="text"
          placeholder="Search by name, ticker, address..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <CreateButton onClick={() => navigate('/create')}>
          Create Token
        </CreateButton>
      </SearchSection>

      {/* Token List - Full view with all filters */}
      <TokenList searchQuery={searchQuery} chainFilter={selectedChain} />
    </PageContainer>
  );
};

export default TradePage;

